import { render } from "./RecentAds.vue?vue&type=template&id=67f234c0&scoped=true"
import script from "./RecentAds.vue?vue&type=script&lang=js"
export * from "./RecentAds.vue?vue&type=script&lang=js"

import "./RecentAds.vue?vue&type=style&index=0&id=67f234c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f234c0"]])

export default __exports__